import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b', NAVY = '#1c1c28';

export default function AppBookingDone() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => {
    const done = sessionStorage.getItem('app_done');
    if (!done) { navigate('/app/home'); return; }
    setD(JSON.parse(done));
  }, [navigate]);

  if (!d) return null;

  return (
    <div style={{ minHeight: '100vh', background: '#fff', maxWidth: 480, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 30, textAlign: 'center' }}>
      <div style={{ width: 100, height: 100, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 50 }}>✅</div>
      <h1 style={{ fontSize: 26, fontWeight: 800, color: INK, marginTop: 22 }}>Booking Confirmed!</h1>
      <p style={{ color: GREY, marginTop: 8, fontSize: 14, lineHeight: 1.6 }}>
        {d.salon_name}<br />{d.date} · {d.slot} · ₹{d.total}
      </p>
      <p style={{ color: GREY, marginTop: 10, fontSize: 12 }}>Salon confirm karega, aapko notification aayegi.</p>

      {d.wa && (
        <button onClick={() => window.open(d.wa, '_blank')} style={{ background: GREEN, color: '#fff', border: 'none', borderRadius: 14, padding: 16, fontSize: 16, fontWeight: 700, width: '100%', maxWidth: 300, marginTop: 24, cursor: 'pointer', boxShadow: '0 8px 20px rgba(34,160,107,.3)' }}>
          📱 Salon ko WhatsApp karein
        </button>
      )}
      <button onClick={() => navigate('/app/home')} style={{ background: NAVY, color: '#fff', border: 'none', borderRadius: 14, padding: 16, fontSize: 16, fontWeight: 700, width: '100%', maxWidth: 300, marginTop: 12, cursor: 'pointer' }}>
        Back to Home
      </button>
      <div style={{ marginTop: 20, color: '#7a7a8c', fontSize: 12, fontWeight: 700 }}>💈 BookYourSalons</div>
    </div>
  );
}
